import { routeGuard } from "../../../router/guard";

export default [
  {
    path: "/listeventsdata",
    name: "ListEventsData",
    beforeEnter: routeGuard,
    component: () =>
      import("../views/index.vue"),
  }
]